$(document).ready(function () {

    $('.surveyForm__checkbox_else').on('click', function () {
        if($(this).is(':checked')) {
            $(this).parents('.surveyForm__checkboxWrap').siblings('.surveyForm__input_else').addClass('active');
        } else {
            $(this).parents('.surveyForm__checkboxWrap').siblings('.surveyForm__input_else').removeClass('active');
        }
    });

    $('.surveyForm__radio').on('click', function () {

        if($(this).hasClass('surveyForm__radio_else')) {
            if($(this).is(':checked')) {
                $(this).parents('.surveyForm__radio-label').siblings('.surveyForm__input_else').addClass('active');
            } else {
                $(this).parents('.surveyForm__radio-label').siblings('.surveyForm__input_else').removeClass('active');
            }
        } else {
            $(this).parents('.surveyForm__radio-label').siblings('.surveyForm__input_else').removeClass('active');
        }

    });

    $('.surveyForm__textarea--to-count').on('input', function () {
        let answerLength = $(this).val() ? $(this).val().length : 0;
        const answerCounter = $(this).closest('.lk-form-item').find(".lk-form-textarea-length-counter");

        answerCounter.text(answerLength);
    });
});
